
import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router';
import _ from 'lodash';

// Import the CSS
import './../../scss/components/_breadcrumb.scss';

export default class Breadcrumb extends Component {

	constructor(props) {
		super(props);
	}

	componentWillReceiveProps(nextProps) {
	}

	render ()  {
		if (this.props.paths) {
			let fullUrl = '';
			let links = _.map(this.props.paths, (path, key) => {
				fullUrl += path.url;

				// don't prepend the slash for the first one
				let label = (key == 0 ? path.label : '/ ' + path.label);

				if (path.hasOwnProperty('fullUrl') && path.fullUrl) {
					return <Link key={key} to={path.url}>{label} </Link>;
				} else {
					return <Link key={key} to={fullUrl}>{label} </Link>;
				}
			});
			return (<div className="breadcrumb"> {links} </div>);
		} else {
			return (<div className="no-breadcrumb-spacer"></div>);
		}
	}
}

Breadcrumb.propTypes = {
	paths: PropTypes.array.isRequired
};




// WEBPACK FOOTER //
// ./src/assets/js/components/Breadcrumb.js